<!-- Start Page Title Area -->
<div class="page-title-area item-bg1 jarallax" data-jarallax='{"speed": 0.3}'>
        <div class="container">
            <div class="page-title-content">
                <ul>
                    <li><a routerLink="/">{{home}}</a></li>
                    <li><a routerLink="/knowledges">{{knowledgeText}}</a></li>
                    <li>{{knowledge.title}}</li>
                </ul>
                <h2>{{knowledgeText}}</h2>
            </div>
        </div>
    </div>
    <!-- End Page Title Area -->
    
    <!-- Start Courses Details Area -->
    <section class="courses-details-area pt-100 pb-70">
        <div class="container">
            <div class="courses-details-header">
                <div class="row align-items-center">
                    <div class="col-lg-12">
                        <div class="courses-title">
                            <h2>{{knowledge.title}}</h2>
                        </div>
                        
                        <div class="courses-meta">
                            <ul>
                                <li *ngIf="knowledge.updatedAt">
                                    <i class='bx bx-calendar'></i>
                                    <span>{{knowledge.updatedAt['seconds'] * 1000 | date:'MMM-dd-yyyy HH:mm:aa' }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
    
                    
                </div>
            </div>
            <div class="row">
                <div class="col-lg-8">
                    <div class="courses-details-image text-center">
                        <!-- <div class="embed-responsive embed-responsive-16by9">
                            <iframe class="embed-responsive-item" [src]="videoUrl" allowfullscreen></iframe>
                        </div> -->
                        <div class="article-image">
                            <img [src]="imageUrl">
                        </div>
                    </div>
    
                    <div class="courses-details-desc">
                        <div [innerHTML]="htmlContent"></div>
                    </div>
                </div>
                <div class="col-lg-4">
                    
                    <aside class="widget-area">
                        <section class="widget widget_raque_posts_thumb">
                            <h3 class="widget-title">{{related}}</h3>
    
                            <article class="item" *ngFor="let knowledge of relateds;">
                                <a href="javascript:;" class="thumb" (click)="onChooseKnowledge(knowledge)">
                                    <img class="fullimage cover" src="{{knowledge.image.fileUrl}}" >
                                </a>
                                <div class="info">
                                    <time datetime="2019-06-30">{{knowledge.updatedAt['seconds'] * 1000 | date:'MMM-dd-yyyy HH:mm:aa' }}</time>
                                    <h4 class="title usmall"><a href="javascript:;" (click)="onChooseKnowledge(knowledge)">{{knowledge.titleEn}}</a></h4>
                                </div>
    
                                <div class="clear"></div>
                            </article>
    
                        </section>
                    </aside>
                </div>
    
            </div>
        </div>
    </section>